import { compose, Modals, Consts } from '../../dependencies';

import Supplier from '../../components/Fields/Supplier';

const modalId = Consts.modals.CREATE_SUPPLIER;

export default compose(Modals.HOC.withModal(modalId))(Supplier);
